export interface ICustomAssetExtraField {
  field: string
  name: string
  description?: string
  type: 'string' | 'number' | 'zip_code' | 'enum'
  enumOptions?: string[]
  customValidation?: (value: any) => boolean | string | void
}

export const companyExtraFields: ICustomAssetExtraField[] = [
  {
    field: 'street',
    name: 'Street',
    type: 'string',
  },
  {
    field: 'number',
    name: 'Number',
    type: 'string',
  },
  {
    field: 'suite',
    name: 'Suite',
    type: 'string',
  },
  {
    field: 'zip',
    name: 'ZIP Code',
    type: 'zip_code',
  },
]

export const realStateExtraFields: ICustomAssetExtraField[] = [
  {
    field: 'type',
    name: 'Type',
    type: 'enum',
    enumOptions: ['COMMERCIAL', 'RESIDENTIAL', 'MIXED USE'],
  },
]
// export const realStateExtraFields: ICustomAssetExtraField[] = [
//   {
//     field: 'tenant_name',
//     name: 'Tenant Name',
//     type: 'string',
//   },
//   {
//     field: 'street',
//     name: 'Street',
//     type: 'string',
//   },
//   {
//     field: 'number',
//     name: 'Number',
//     type: 'string',
//   },
//   {
//     field: 'suite',
//     name: 'Suite',
//     type: 'string',
//   },
//   {
//     field: 'zip',
//     name: 'ZIP Code',
//     type: 'zip_code',
//   },
//   {
//     field: 'city',
//     name: 'City',
//     type: 'string',
//   },
//   {
//     field: 'state',
//     name: 'State',
//     type: 'string',
//   },
// ]
